import { AttributesMixin, define, Model, type } from "@type-r/models";
import { AssetStateIds } from "../../api/assetStateIds";
import { AssetType } from "../../api/assetType";
import { DateFilter, formatDateFilter } from "../../components/search-bar/filters/date-filter";
import { DateRangeFilter } from "../../components/search-bar/filters/date-range-filter";
import { MultiSelectChipsFilter } from "../../components/search-bar/filters/multiselect-chips-filter";
import { TextFilter } from "../../components/search-bar/filters/text-filter";

const defaultSort = {
    attr: "createdOn",
    asc: false
};

export const SortOptions = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}

export const CreditNoteStateOptions = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: AssetStateIds.PendingCreditNote,
        label: 'Pending'
    },
    {
        value: AssetStateIds.DigitizedCreditNote,
        label: 'Digitized'
    }
]

export interface CreditNotesFilters extends AttributesMixin<typeof CreditNotesFilters> { }

@define
export class CreditNotesFilters extends Model {
    static attributes = {
        filterAll: '',
        suppliers: type(MultiSelectChipsFilter),
        buyers: type(MultiSelectChipsFilter),
        amount: type(TextFilter),
        currency: type(TextFilter),
        issuanceDate: type(DateFilter),
        invoiceNumber : type(TextFilter),
        creditNoteNumber : type(TextFilter),
        expirationDate : type(DateRangeFilter),
        sortBy: type(defaultSort),
        stateId: 0,
        importJobId: type(TextFilter),
        assetUid: type(TextFilter),
    }

    reset() {
        this.filterAll = '';
        this.suppliers.$.selected.set([] as any);
        this.buyers.$.selected.set([] as any);
        this.amount.$.value.set('');
        this.currency.$.value.set('');
        this.issuanceDate.$.date.set(null);
        this.invoiceNumber.$.value.set('');
        this.creditNoteNumber.$.value.set('');
        this.expirationDate.set({from: undefined, to: undefined});
        this.importJobId.$.value.set('');
        this.assetUid.$.value.set('');
    }

    mapToQuery(skip: number = 0, take: number = 1000, stateId?: number) {
        const params: any = { skip: skip, count: take, assetTypeId: AssetType.creditNote};

        if (this.buyers.selected && this.buyers.selected.length)
        {
            params.buyers = this.buyers.selected;
            params.buyers = params.buyers.join('|');
        }
        else if (this.suppliers.selected && this.suppliers.selected.length)
        {
            params.suppliers = this.suppliers.selected;
            params.suppliers = params.suppliers.join('|');
        }
        if (this.amount.value)
        {
            params.amount = this.amount.value;
        }
        else if (this.currency.value)
        {
            params.currency = this.currency.value;
        }
        else if (this.issuanceDate.date)
        {
            params.issuanceDate = formatDateFilter(this.issuanceDate.date);
        }
        else if (this.invoiceNumber.value)
        {
            params.invoiceNumber = this.invoiceNumber.value;
        }
        else if (this.creditNoteNumber.value)
        {
            params.creditNoteNumber = this.creditNoteNumber.value;
        }
        else if (this.expirationDate.from || this.expirationDate.to)
        {
            if(this.expirationDate.from)
                params.expirationDateFrom = formatDateFilter(this.expirationDate.from);
            if(this.expirationDate.to)
                params.expirationDateTo = formatDateFilter(this.expirationDate.to);
        }
        else if (this.filterAll && this.filterAll.length > 2)
        {
            params.matchAll = this.filterAll;
        }
        else if (this.importJobId.value){
            params.importJobId = this.importJobId.value
        }
        else if (this.assetUid.value) {
            params.uid = this.assetUid.value;
        }

        if (stateId > 0)
        {
            params.stateId = stateId;
        }
        else if (this.stateId > 0)
        {
            params.stateId = this.stateId;
        }

        if (this.sortBy)
        {
            params.sortBy = this.sortBy.attr;
            params.sortDirection = this.sortBy.asc ? 'asc' : 'desc';
        }
        return params;
    }
}
